import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp } from "lucide-react";
import { IMAGES, imgUrl } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export default function LeadStory() {
  return (
    <section id="news" data-testid="lead-story-section" className="grain bg-atlantic py-24 lg:py-32">
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="relative mb-14 flex items-end justify-between gap-6">
          <span aria-hidden="true" className="pointer-events-none absolute -top-12 right-0 select-none font-serif text-7xl text-white/[0.06] sm:text-8xl">02</span>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">Featured Lead Story</p>
            <h2 className="mt-4 font-serif text-3xl tracking-tight text-white sm:text-4xl">News & Analysis</h2>
          </div>
          <span className="hidden h-px flex-1 bg-white/15 md:block" aria-hidden="true" />
        </div>

        <Reveal>
        <article className="relative grid grid-cols-1 gap-0 border border-white/10 lg:grid-cols-12" data-testid="lead-story-card">
          <div className="relative overflow-hidden lg:col-span-7">
            <img
              src={imgUrl(IMAGES.diplomacy, 1400)}
              alt="Diplomatic meeting room in black and white"
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
            />
          </div>
          <div className="flex flex-col justify-center bg-atlantic-light p-8 sm:p-12 lg:col-span-5">
            <p data-testid="lead-story-category" className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold">
              Ghana–Jamaica Relations
            </p>
            <h3 data-testid="lead-story-headline" className="mt-5 font-serif text-2xl leading-snug text-white sm:text-3xl">
              From Barrier to Bridge: What Ghana and Jamaica Must Build After the Presidential Visit
            </h3>
            <p className="mt-5 text-sm leading-relaxed text-white/70 sm:text-base">
              Ghana and Jamaica have moved beyond diplomacy in at least one measurable area: 43 Ghanaian specialist nurses
              have joined Jamaica's health workforce. Our source-linked analysis examines what has been delivered,
              what remains promised and what comes next.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                data-testid="lead-story-read-button"
                to="/analysis/ghana-jamaica-presidential-visit"
                className="group flex items-center gap-2 bg-gold px-6 py-3 text-sm font-semibold text-atlantic transition-colors hover:bg-gold-light"
              >
                Read the Analysis
                <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                data-testid="lead-story-tracker-button"
                to="/research/cooperation-tracker"
                className="group flex items-center gap-2 border border-white/30 px-6 py-3 text-sm font-semibold text-white transition-colors hover:border-gold hover:text-gold"
              >
                <TrendingUp size={15} />
                Follow the Cooperation Tracker
              </Link>
            </div>
          </div>
        </article>
        </Reveal>
      </div>
    </section>
  );
}
